import React, { useEffect, useState } from 'react'
import Headar from '../Component/Headar'
import MobileHader from '../Component/MobileHader'
import BannerSection from '../Component/BannerSection'
import Footer from '../Component/Footer'
import MemberShip from '../Component/MemberShip'
import { InfinitySpin } from "react-loader-spinner";
import BradCrum from '../Component/BradCrum'

const Packges = () => {
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    // Simulate a delay of 2 seconds (adjust as needed)
    const delay = 1000;
    setTimeout(() => {
      setIsLoading(false);
    }, delay);
  }, []);
  return (
    <React.Fragment>
           {isLoading ? (
        // Loader component while loading
        <div className="loader-container">
          <InfinitySpin
            color="#000"
            height={50}
           width="200"
            timeout={0} // 0 means no timeout, loader will be displayed until setIsLoading(false) is called
          />
        </div>
      ) : (
      <div>
        <Headar />
        <MobileHader />
        <BradCrum Title="Packges" />
        {/* <BannerSection /> */}
        <MemberShip />
    <Footer />
    </div>
      )}
    </React.Fragment>
  )
}

export default Packges